module.exports = __webpack_public_path__ + "assets/webgl/Frame_Ornament_materialParams.1001.jpg.pvr.83e13a53.ktx";